/**
 * Servicio para obtener un segmento de usuario específico.
 * Utilizado para clasificar o identificar a un usuario dentro de un grupo predefinido.
 * @param {string} queryParams - Parámetros de consulta para identificar y obtener el segmento.
 * @returns {Promise<{ Titles, Styles, Combos, Counter } | null >} Promesa que resuelve con la información del segmento del usuario.
 */
export async function getSegment(queryParams) {
  const { idWall, apiKey, apiPaywallURL } = window.LN.PaywallHub;
  const $WallId = document.getElementById("wallId");
  const wallIdValue = idWall ?? $WallId.innerText;
  const request = `${apiPaywallURL}/api/paywall/v2/walls/${wallIdValue}/segments?q=${encodeURIComponent(
      queryParams
  )}`;

  return await fetch(request, {
    method: "GET",
    headers: {
      apikey: apiKey,
    },
  })
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => {
      console.error("Error:", error);
      DD_LOGS?.logger?.error("fetch segments", {
        queryParams,
        WallId: idWall,
        Error: error,
      });
    });
  
}



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/services/segmentos.js